

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {HarlequinGameConfig} from "../../HarlequinGameConfig";
import {Timeline, TimelineLite, TweenMax, TweenLite} from "gsap";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import Sprite = PIXI.Sprite;
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {HarlequinReelSymbol} from "../../symbols/HarlequinReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class HarlequinWalkerView extends BaseView {

    public static ALL_ACTIVE_WALKER_IDS:string [] = [];
    private _layer:ScalableLayer;
    private _mpSprite:Sprite;

    private _walkerSpine:PIXI.spine.Spine;
    private _isRestored:boolean = false;

    private _activeWalkers: {
        sprite : Sprite,
        currentStep : number,
        uniqueId : string,
        textSprite : PIXI.spine.Spine,
        symWinSpines : PIXI.spine.Spine [],
        kill? : boolean
    }[] = [];

    protected stackWildWinSprite:Sprite | null;
    protected stackWildWinSpine:PIXI.spine.Spine | null;
    private _activeNoWinStacks: number [][] = [];


    constructor() {
        super();

        this._layer = StageManager.getLayer(HarlequinGameConfig.instance.LAYERS.HARLEQUIN_WALKER.name);
        this._layer.addChild(this);
    }

    public restoreReset():void {
        this._isRestored = false;
    }

    initAnimations() {
    }

    // only create on win/noWin situation
    protected createStackWildWinSpine(symId:number):PIXI.spine.Spine {
        const spine:PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("stackWildWinSpine"));

        spine.name = "sym" + symId;
        spine.autoUpdate = true;
        spine.scale.set(1.05, 1.05);

        return spine;
    }

    public getActiveWalkerOnReel(reelId:number):any | null {
        let returnVal:any | null = null;

        this._activeWalkers.forEach((walker) => {
            if(reelId === walker.currentStep) {
                //console.log("walkerInfo", walker);
                returnVal = walker;
            }
        });

        return returnVal;
    }

    protected winSpineComplete(trackEntry:PIXI.spine.core.TrackEntry, spineObj?:PIXI.spine.Spine, allSpines?:PIXI.spine.Spine []):void {
        if(trackEntry.animation.name === "WildInitialWin") {
            if(spineObj) {
                spineObj.state.setEmptyAnimation(0,0);
                if(allSpines) {
                    allSpines.forEach((spine) => {
                        if (spine) {
                            spine.state.setEmptyAnimation(0, 0);
                        }
                    });
                }
                //spineObj.state.setAnimation(0, "WildidlelWinOnNonWiningPart", true);
            }
        }
        if(trackEntry.animation.name === "WildInitialWinOnNonWiningPart") {
            if(spineObj) {
                spineObj.state.setAnimation(0, "WildidlelWinOnNonWiningPart", true);
            }
        }
    }

    public playWildWinSpine(winName:string, reelId:number, symId:number, loop:boolean = false, onComplete?:(trackEntry:PIXI.spine.core.TrackEntry,
    spineObj?:PIXI.spine.Spine, allSpines?:PIXI.spine.Spine []) => void, activeWins: number [][] = [], noWin:boolean = false):void {

        const walkerInfo:any | null = this.getActiveWalkerOnReel(reelId);

        if(walkerInfo !== null && walkerInfo.symWinSpines[symId]) {
            this._activeNoWinStacks.push([reelId, symId]);
            walkerInfo.symWinSpines[symId].state.setAnimation(0, winName, loop);

            if(onComplete) {
                // Add callback to listener
                walkerInfo.symWinSpines[symId].state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete: (entry:PIXI.spine.core.TrackEntry, spineObj?:PIXI.spine.Spine, allSpines?:PIXI.spine.Spine []) => {
                        this.winSpineComplete(entry, walkerInfo.symWinSpines[symId], walkerInfo.symWinSpines);
                        onComplete(entry, walkerInfo.symWinSpines[symId], walkerInfo.symWinSpines);
                    }
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                });
            }
        }

        if(!walkerInfo && !noWin){
            // If no walker we can assume we have a symbol on same position
            const symbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, symId);
            if(symbol && symbol.symName.indexOf("W") > -1) {
                if(symId === 0) {
                    const fsymbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, 1);
                    if(fsymbol){
                        fsymbol.playStackWin(0);
                    }
                }else {
                    symbol.playStackWin(symId);
                }
            }
        }
        else {
            const symbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, symId);
            if(symbol && symbol.symName.indexOf("W") > -1) {
                if(symId === 0) {
                    const fsymbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, 1);
                    if(fsymbol){
                        fsymbol.playStackNoWin(0);
                    }
                }
                else {
                    symbol.playStackNoWin(symId);
                }

            }
        }
    }

    public playWildWinSpineToNormal(winName:string, reelId:number, symId:number) {
        this._activeNoWinStacks.forEach((pos:number []) => {
            const walkerInfo:any | null = this.getActiveWalkerOnReel(reelId);
            if(walkerInfo !== null && walkerInfo.symWinSpines[symId]) {
                walkerInfo.symWinSpines[pos[1]].state.setEmptyAnimation(0, 0);
            }
        });
        this._activeNoWinStacks.length = 0;
    }

    public playNoWinWildStack(animName:string):void {
        /*if(!this.stackWildWinSpine && !this.stackWildWinSprite) {
            this.stackWildWinSpine = this.createStackWildWinSpine();
            this.stackWildWinSprite = new Sprite();
            if(this.stackWildWinSprite && this.stackWildWinSpine) {
                this.stackWildWinSprite.addChild(this.stackWildWinSpine);
                this.addChild(this.stackWildWinSprite);
            }

            this.playWildWinSpine(animName, true);
        }*/
    }

    onResize(resizeData:IResizeData) {

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this.x = -280;
            this.y = -191;

            this.scale.set(1, 1);
            //this.position.set(0, 0);
        } else {
            //this.y = -225;
            this.position.set(-208.5, -40);
            this.scale.set(0.87, 0.87);
        }
    }

    protected createOverlay(noNudge:boolean = false, forceAnimation?:boolean, mpVal?:number):Sprite {
        const sprite = new Sprite();

        this._walkerSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("wildWalker"));
        this._walkerSpine.name = "spine";
        sprite.addChild(this._walkerSpine);
        this._walkerSpine.autoUpdate = true;
        if(!noNudge) {
            this._walkerSpine.state.setAnimation(0, (forceAnimation && mpVal)? "X" + mpVal + "Idle" : "X2", false);
        }
        else {
            this._walkerSpine.state.setAnimation(0, "X1Idle", false);
        }
        this._walkerSpine.y = 200;

        sprite.anchor.set(0.5, 0.165);
        sprite.position.set(Helper.getSymbolPositions(2, 0)[0], Helper.getSymbolPositions(2, 0)[1] + 1.75);

        /*const mpSprite:Sprite = new Sprite(PIXI.Texture.WHITE);
        mpSprite.tint = 0x000000;
        mpSprite.name = "txtSprite";
        mpSprite.anchor.set(0.5, 0.5);
        mpSprite.width = sprite.width;
        mpSprite.height = sprite.height/3.7;
        mpSprite.y = 147 * 3;

        this._mpSprite = mpSprite;*/

        //sprite.addChild(mpSprite);
        sprite.visible = false;

        return sprite;
    }

    public restoreWilds(wildMultipliers:number [] = [], delay:number = 0.3):Timeline {
        const tl:Timeline = new TimelineLite();

        // TODO: Add same restore logic for all wilds, not only wild drop
        if(wildMultipliers.length > 0) {
            //this._isRestored = true;
        }
        wildMultipliers.forEach((mpVal:number, index) => {
            if(mpVal > 0) {
                tl.add([
                    this.restoreAndShowOverlay(index, undefined, wildMultipliers, true, mpVal, true)
                ], "+=0");
            }
        });

        tl.add(() => {
            //this._isRestored = true;
        }, "+=" + delay);
        return tl;
    }

    public addAndShowWildDrop(reelId:number, multiplierArray:number [] = []):Timeline {
        const tl:Timeline = new TimelineLite();
        const walker:Sprite = this.createOverlay();
        const activeId:string = "walker :: " + Date.now() + " :: " + reelId;
        const symWinSpines:PIXI.spine.Spine [] = [];


        // TODO: Animation states
        // "WildInitialWinOnNonWiningPart"
        // "WildInitialWin"
        // "Wildidle"
        // "WildidlelWinOnNonWiningPart"
        // "WildtogleWin"
        // "WildtoglelWinOnNonWiningPart"

        // Add stack wild win spines on individual sym pos
        [0, 1, 2].forEach((value:number) => {
            //const sprite:Sprite = new Sprite();
            const spine:PIXI.spine.Spine = this.createStackWildWinSpine(value);

            //spine.state.setAnimation(0, "WildInitialWin", true);

            spine.position.set(0, (value * 190) + ((value + 1) * 11));
            //spine.position.set(0, this.getYposForWinSpine(value));

            //sprite.addChild(spine);
            walker.addChild(spine);

            symWinSpines.push(spine);
        });

        const tempWalker:any = {
            sprite: walker,
            currentStep: reelId,
            uniqueId: "temp",
            textSprite: <PIXI.spine.Spine> walker.getChildByName("spine"),
            symWinSpines: symWinSpines
        };

        //let tmpSprite:Sprite = <PIXI.Sprite> walker.getChildByName("txtSprite");
        this._activeWalkers.push(tempWalker);

        //onsole.log(this._activeWalkers);
        //callback(activeId);
        HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.push(activeId);

        tl.add([
            () => {
                walker.position.set(Helper.getSymbolPositions(reelId, 0)[0], Helper.getSymbolPositions(reelId, 0)[1] + 1.75);
                walker.visible = true;
                walker.alpha = 0;
                this.updateMultiplier(tempWalker.textSprite, 3, true);
                this.addChild(walker);
            }
        ]);
        tl.add([
            TweenLite.fromTo(walker, 0.2, {
                alpha: 0
            }, {
                alpha: 1
            })
        ]);
        tl.add(() => {
            // TODO: temp delay
        }, 1.5); // TODO: ?? not really apllying the delay

        return tl;
    }

    public restoreAndShowOverlay(reelId:number, callback:(walkerId:string) => void = () => {}, multiplierArray:number [], forceAnimation?:boolean, mpVal?:number, flush:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();
        let walker:Sprite;

        if(flush) {
            walker = this.createOverlay(false, forceAnimation, mpVal)
        }
        else {
            walker = (multiplierArray[reelId] === 1) ? this.createOverlay(true) : this.createOverlay(false, forceAnimation, mpVal);
        }
        const activeId: string = "walker :: " + Date.now() + " :: " + reelId;
        const symWinSpines:PIXI.spine.Spine [] = [];


        // TODO: Animation states
        // "WildInitialWinOnNonWiningPart"
        // "WildInitialWin"
        // "Wildidle"
        // "WildidlelWinOnNonWiningPart"
        // "WildtogleWin"
        // "WildtoglelWinOnNonWiningPart"

        // Add stack wild win spines on individual sym pos
        [0, 1, 2].forEach((value:number) => {
            //const sprite:Sprite = new Sprite();
            const spine:PIXI.spine.Spine = this.createStackWildWinSpine(value);

            spine.state.setAnimation(0, "Wildidle", true);

            spine.position.set(0, (value * 190) + ((value + 1) * 11));
            // spine.position.set(0, this.getYposForWinSpine(value));
            //sprite.addChild(spine);
            walker.addChild(spine);

            symWinSpines.push(spine);
        });

            this._activeWalkers.push({
                sprite: walker,
                currentStep: reelId,
                uniqueId: activeId,
                textSprite: <PIXI.spine.Spine>walker.getChildByName("spine"),
                symWinSpines: symWinSpines,
                kill: flush
            });


        if(!flush) {
            HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.push(activeId);
        }

        tl.add([
            () => {
                walker.position.set(Helper.getSymbolPositions(reelId, 0)[0], Helper.getSymbolPositions(reelId, 0)[1] + 1.75);
                walker.visible = true;
                this.addChild(walker);
            }
        ]);

        return tl;
    }

    public addAndShowOverlay(reelId:number, callback:(walkerId:string) => void = () => {}, multiplierArray:number [], forceAnimation?:boolean, mpVal?:number, restoreOnReelZero:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();

        if(restoreOnReelZero) {
            return tl;
        }

        const walker:Sprite = (multiplierArray[reelId] === 1)? this.createOverlay(true) : this.createOverlay(false, forceAnimation, mpVal);
        const activeId: string = "walker :: " + Date.now() + " :: " + reelId;
        const symWinSpines:PIXI.spine.Spine [] = [];

        // Add stack wild win spines on individual sym pos
        [0, 1, 2].forEach((value:number) => {
            //const sprite:Sprite = new Sprite();
            const spine:PIXI.spine.Spine = this.createStackWildWinSpine(value);

            spine.state.setAnimation(0, "Wildidle", true);
            //spine.scale.set(1, 1)

            spine.position.set(0, (value * 190) + ((value + 1) * 11));
            //spine.position.set(0, this.getYposForWinSpine(value));
            //sprite.addChild(spine);
            walker.addChild(spine);

            symWinSpines.push(spine);
        });

            this._activeWalkers.push({
                sprite: walker,
                currentStep: reelId,
                uniqueId: activeId,
                textSprite: <PIXI.spine.Spine>walker.getChildByName("spine"),
                symWinSpines: symWinSpines
            });


            //console.log(this._activeWalkers);
            //callback(activeId);
            HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.push(activeId);


        tl.add([
            () => {
                walker.position.set(Helper.getSymbolPositions(reelId, 0)[0], Helper.getSymbolPositions(reelId, 0)[1] + 1.75);
                walker.visible = true;
                this.addChild(walker);
            }
        ]);
        tl.add(() => {
           // TODO: temp delay
        }, 1);

        return tl;
    }

    public moveAllOverlays(multiplierArray:number []):Timeline {
        const tl:Timeline = new TimelineLite();

        this._activeWalkers.forEach((walkerInfo, index) => {

            if(walkerInfo.kill) {
                walkerInfo.sprite.visible = false;
                this.removeChild(walkerInfo.sprite);
                //walkerInfo.sprite.destroy();
            }
            else if ((walkerInfo.currentStep - 1) >= 0) {
                tl.add([
                    () => {
                        walkerInfo.symWinSpines.forEach((spine) => {
                            spine.state.setEmptyAnimation(0, 0);
                        });
                    },
                    TweenLite.to(walkerInfo.sprite.position, 0.2, {
                        x: Helper.getSymbolPositions(walkerInfo.currentStep - 1, 0)[0],
                        y: Helper.getSymbolPositions(walkerInfo.currentStep - 1, 0)[1] + 1.75
                    }),
                    //,
                    () => this.updateMultiplier(walkerInfo.textSprite, multiplierArray[walkerInfo.currentStep + 1]),
                    () => {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_STEP);
                    }
                ]);

            }

            walkerInfo.currentStep--;
        });
        tl.add(() => {
            this._isRestored = false;
        });

        return tl
    }

    public moveAllOverlaysFS(multiplierArray:number []):Timeline {
        const tl:Timeline = new TimelineLite();

        this._activeWalkers.forEach((walkerInfo, index) => {
            if(walkerInfo.kill) {
                walkerInfo.sprite.visible = false;
                this.removeChild(walkerInfo.sprite);
                //walkerInfo.sprite.destroy();
            }
            else if ((walkerInfo.currentStep - 1) >= 0) {
                tl.add([
                    () => {
                        walkerInfo.symWinSpines.forEach((spine) => {
                            spine.state.setEmptyAnimation(0, 0);
                        });
                    },
                    TweenLite.to(walkerInfo.sprite.position, 0.2, {
                        x: Helper.getSymbolPositions(walkerInfo.currentStep - 1, 0)[0],
                        y: Helper.getSymbolPositions(walkerInfo.currentStep - 1, 0)[1] + 1.75
                    }),
                    //,
                    () => this.updateMultiplier(walkerInfo.textSprite, (multiplierArray[walkerInfo.currentStep + 1]) + 1, undefined, true),
                    () => {
                        SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_STEP);
                    }
                ]);

            }

            walkerInfo.currentStep--;
        });

        return tl
    }

    public flush(wildDrop:boolean = false):void {
        if(this._activeWalkers.length > 0) {
            const flushIndexes:number [] = [];
            const activesToFlush:number [] = [];

            this._activeWalkers.forEach((walkerInfo, index) => {

                /*if(walkerInfo.kill) {
                    walkerInfo.sprite.visible = false;
                    this.removeChild(walkerInfo.sprite);
                    //walkerInfo.sprite.destroy();
                }*/

                if(wildDrop && walkerInfo.uniqueId === "temp") {
                    this.removeOverlay(walkerInfo.sprite);
                    if(HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.indexOf(walkerInfo.uniqueId) > -1) {
                        flushIndexes.push(HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.indexOf(walkerInfo.uniqueId));
                        activesToFlush.push(index);
                    }
                }
                else if(!wildDrop && walkerInfo.currentStep <= 0) {
                    this.removeOverlay(walkerInfo.sprite);
                    if(HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.indexOf(walkerInfo.uniqueId) > -1) {
                        flushIndexes.push(HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.indexOf(walkerInfo.uniqueId));
                        activesToFlush.push(index);
                    }
                }
            });

            flushIndexes.forEach((flushi) => {
                 HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.splice(flushi, 1);
            });
            activesToFlush.forEach((flushi) => {
                this._activeWalkers.splice(flushi, 1);
            });
        }
    }

    public hardReset():void {
        HarlequinWalkerView.ALL_ACTIVE_WALKER_IDS.length = 0;
        this._activeWalkers.length = 0;
        this._activeNoWinStacks.length = 0;
    }

    public removeOverlay(sprite:Sprite):Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add([
            TweenLite.to(sprite, 0.4, {
                alpha: 0
            })
        ]);
        tl.add(() => {
            this.removeChild(sprite);
            sprite.visible = false;
            sprite.alpha = 1;
        });

        return tl
    }

    public updateMultiplier(spine:PIXI.spine.Spine, mpValue:number, idle:boolean = false, inFreespin:boolean = false):Timeline {
        const tl:Timeline = new TimelineLite();
        if(idle) {
            tl.add([
                (mpValue > 0) ? () => spine.state.setAnimation(0, "X" + mpValue + "Idle", false) : () => {
                } // TODO: somewhat temp solution, will prolly chnage when nudge is in place
            ]);
        }
        else {
            tl.add([
                (mpValue >= 1) ? () => spine.state.setAnimation(0, (mpValue > 1)? "X" + (mpValue) : "X", false) : () => {
                } // TODO: somewhat temp solution, will prolly chnage when nudge is in place

            ]);
            //if(inFreespin) {
                tl.add((mpValue >= 1) ? () => {
                    SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WILD_MULTIPLIER);
                } : () => {}, "+=0.25")
            //}
        }

        return tl
    }

    public updateAllMultipliers(valueArr:number []):Timeline {
        const tl:Timeline = new TimelineLite();

        tl.add([
            () => TweenMax.to(this._mpSprite.scale, 0.2, {
                x: 1.01,
                y: 1.01,
                repeat: 1,
                yoyo: true
            })
        ]);

        return tl
    }

}